module.exports = __webpack_public_path__ + "media/images/viessmann_banner/banner_V1-b5bd74f3178a4f50ab7199968aa27911.png";